import React from 'react';
import Header from '../components/Header';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const PreguntasFrecuentesPage = () => {
  const seoData = {
    title: 'Preguntas Frecuentes',
    description: 'Respuestas a las preguntas más comunes sobre Runamatic. Conoce todo sobre nuestros planes, integraciones, soporte y funcionalidades.',
    keywords: 'preguntas frecuentes runamatic, FAQ, soporte runamatic, ayuda automatización, preguntas planes, preguntas integraciones',
    canonical: '/preguntas-frecuentes',
    ogTitle: 'Preguntas Frecuentes - Runamatic',
    ogDescription: 'Encuentra respuestas a tus preguntas sobre automatización, planes, integraciones y más. Centro de ayuda Runamatic.',
    schema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "name": "Preguntas Frecuentes - Runamatic",
      "description": "Preguntas y respuestas frecuentes sobre la plataforma de automatización Runamatic",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "¿Qué cuentas de Instagram / Facebook puedo automatizar?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Solo las cuentas de tipo empresa y/o creador pueden ser vinculadas con nuestro servicio."
          }
        },
        {
          "@type": "Question",
          "name": "¿Qué incluye el acceso a la plataforma?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Nuestra plataforma ofrece: Analíticas, CRM, Bandeja de entrada unificada de todas las plataformas conectadas, Usuarios ilimitados con distinto nivel de acceso, Seguimiento de mensajes, Mensajería masiva para los canales conectados, Creador visual de flujos de trabajo, Sección de contactos para filtrar / exportar / importar, Manejo de palabras claves, Herramientas para automatización de comentarios en posts de Facebook e Instagram, Generador de códigos QR, Herramienta de gestión de calendarios, Herramienta E-Commerce para trabajar con catálogos de productos / servicios, Herramienta para gestionar ubicaciones, Webhooks y API requests para conectar con otros sistemas, Herramienta de simulación del bot para mostrar a clientes, Modo desarrollo para hacer pruebas sin impactar a sus clientes. Entre otras funcionalidades."
          }
        },
        {
          "@type": "Question",
          "name": "¿Cuánto tardo en automatizar mis canales de ventas?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Eso depende de la estrategia que quieras lograr, por lo general conectar las cuentas y escribir un prompt básico puede llevar desde 5 a 15 minutos dependiendo la cantidad de cuentas. Puede ser que implementar estrategias avanzadas lleve más tiempo, nuestra interfaz es muy amigable para los nuevos usuarios."
          }
        },
        {
          "@type": "Question",
          "name": "¿Qué incluye el Plan Full?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "El Plan Full incluye asesoría completa de estrategia comercial, análisis y mejora de procesos, y la configuración 100% personalizada por nuestro equipo. Incluye todas las herramientas del Plan Pro más: asesoría estratégica comercial, grupo de WhatsApp dedicado, reunión inicial de análisis de marca, propuesta de soluciones tecnológicas, demo antes de conectar canales reales, conexión a todos los canales reales (WhatsApp, Instagram, TikTok, Telegram, etc.) y refinamiento continuo."
          }
        },
        {
          "@type": "Question",
          "name": "¿Qué diferencia hay entre el Plan Pro y el Plan Full?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "El Plan Pro da acceso completo a todas las herramientas de la plataforma con IA incluida (OpenAI GPT-4o) y todos los canales, en modalidad auto gestión. El Plan Full incluye todo el Plan Pro más asesoría completa de estrategia comercial y configuración 100% personalizada por nuestro equipo experto."
          }
        },
        {
          "@type": "Question",
          "name": "¿Precios en pesos Argentinos?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ofrecemos precios en pesos Argentinos, pero es importante saber que toda la infraestructura detrás de nuestro sistema consume servicios del exterior y por ellos nuestros precios serán actualizados."
          }
        },
        {
          "@type": "Question",
          "name": "¿Puedo crear chatbots para mis clientes?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Claro que si, en caso de que este sea tu objetivo te enviaremos tutoriales para poder conectar las cuentas de tus clientes y comenzar a vender chatbots."
          }
        },
        {
          "@type": "Question",
          "name": "¿Qué son los tokens de OpenAI y para que sirven?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Los tokens de Open AI son la unidad que se utiliza para medir el consumo de recursos de la AI. El consumo de tokens por respuesta va a variar dependiendo la configuración del bot y el tipo de herramientas utilizadas en la configuración de la cuenta. La generación de texto es el mecanismo que menor cantidad de tokens consume, la generación de audio e imágenes consume mayor cantidad de tokens. Un ejemplo general: 'Hola! como te va? como te puedo ayudar hoy? Recuerda que tenemos promociones especiales por el día de la madre!' Esta respuesta consume 25 tokens. Los tokens son contados cuando el usuario envía mensajes y cuando la AI responde. Importante: Los planes Pro y Full incluyen 3 millones de tokens de OpenAI que se renuevan mensualmente. Runamatic ofrece herramientas como botones, respuestas automatizadas por palabras claves que no tienen consumo alguno en recursos de la AI."
          }
        },
        {
          "@type": "Question",
          "name": "¿Trabajan con mi número de WhatsApp?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Si, podemos integrar tu cuenta existente de WhatsApp Business y si no tienes podemos crear una nueva cuenta de WhatsApp Cloud API. Podemos trabajar de las dos maneras. Esto te ofrece poder seguir viendo los mensajes en tu teléfono y al mismo tiempo usar las automatizaciones."
          }
        },
        {
          "@type": "Question",
          "name": "¿Tenés más preguntas?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Escribinos por WhatsApp con el link que encontrarás más abajo, también podés escribirnos a hola@runamatic.io. Encontrá a nuestro equipo de soporte por el chat interno de nuestra plataforma, simplemente pedile a la AI que te comunique con un humano."
          }
        }
      ]
    }
  };

  return (
    <>
      <SEO {...seoData} />
      <Header />
      <main>
        <FAQSection />
      </main>
      <Footer />
    </>
  );
};

export default PreguntasFrecuentesPage; 